import React from "react";
import MuiCheckbox from "@mui/material/Checkbox";
import PropTypes from "prop-types";

/**
 * Checkbox component wrapper for checkbox inputs.
 * Wraps Material-UI Checkbox with theme integration.
 * 
 * @component
 * @example
 * <Checkbox
 *   checked={checked}
 *   onChange={handleChange}
 *   color="primary"
 * />
 */
const Checkbox = (props) => {
  return <MuiCheckbox {...props} />;
};

Checkbox.propTypes = {
  /**
   * If true, the component is checked
   */
  checked: PropTypes.bool,
  /**
   * The icon to display when the component is checked
   */
  checkedIcon: PropTypes.node,
  /**
   * The color of the component
   */
  color: PropTypes.oneOf([
    "default",
    "primary",
    "secondary",
    "error",
    "info",
    "success",
    "warning",
  ]),
  /**
   * If true, the component will be disabled
   */
  disabled: PropTypes.bool,
  /**
   * If true, the ripple effect will be disabled
   */
  disableRipple: PropTypes.bool,
  /**
   * The icon to display when the component is unchecked
   */
  icon: PropTypes.node,
  /**
   * The id of the input element
   */
  id: PropTypes.string,
  /**
   * If true, the component appears indeterminate
   */
  indeterminate: PropTypes.bool,
  /**
   * The icon to display when the component is indeterminate
   */
  indeterminateIcon: PropTypes.node,
  /**
   * Attributes applied to the input element
   */
  inputProps: PropTypes.object,
  /**
   * Callback fired when the state is changed
   */
  onChange: PropTypes.func,
  /**
   * If true, the input element will be required
   */
  required: PropTypes.bool,
  /**
   * The size of the component
   */
  size: PropTypes.oneOf(["small", "medium", "large"]),
  /**
   * The value of the component
   */
  value: PropTypes.any,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles
   */
  sx: PropTypes.oneOfType([
    PropTypes.arrayOf(
      PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])
    ),
    PropTypes.func,
    PropTypes.object,
  ]),
};

// No defaultProps - maintain exact MUI Checkbox behavior
// MUI Checkbox defaults: color="primary", size="medium"

export default Checkbox;

